import { Component, inject, CUSTOM_ELEMENTS_SCHEMA, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SidebarComponent } from '../shared/sidebar/sidebar.component';
import { TopbarComponent } from '../shared/topbar/topbar.component';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-admin',
  standalone: true,
  imports: [SidebarComponent, TopbarComponent, RouterModule],
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AdminComponent implements OnInit {
  private router = inject(Router);
  private translationService = inject(TranslationService);
  private cdr = inject(ChangeDetectorRef); // Para forzar la actualización del DOM

  translations: any = {};

  ngOnInit() {
    this.translationService.getTranslations().subscribe(translations => {
      this.translations = translations;
      this.cdr.detectChanges(); // Forzar actualización en la vista
    });
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  getTranslation(key: string): string {
    return this.translations[key] || key;
  }
}
